import React from "react";
import BaseComponent from "../../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import Type from "../../../Global/Typography.js";
import Image from "../../../Nano/Image.js";

// import playIcon from "./../Global/Icons/play.svg";
import { ReactComponent as PlayIcon } from "../../../Global/Icons/play.svg";

import { ReactComponent as Download } from "../../../Global/Icons/download.svg";
import { ReactComponent as EditCard } from "../../../Global/Icons/editCard.svg";
import { ReactComponent as NotaSelectionLabel } from "../../../Global/Icons/label.svg";
import { ReactComponent as RequestInfoIcon } from "../../../Global/Icons/requestInfoIcon.svg";

const multiple = nota.global.multiple;

const StyledProgrammeImageBlock = styled(NanoFlex)`
  width: 100%;

  .headerCard {
    /* background-color: ${nota.color.main.default}; */
    padding: ${multiple + "px"} 0;
    /* padding-right: ${multiple / 2 + "px"}; */
    .titleCard {
      width: calc(100% - 35px);
      h2 {
        max-width: 100%;
        color: ${nota.color.secondary.secAquaGreen};
        b {
          color: ${nota.color.secondary.secAquaGreen};
        }
      }

      .secTitlesCardWrapper {
        margin-top: ${multiple / 2 + "px"};
        .secTitlesCard {
          width: auto;
          h4 {
            color: ${nota.color.secondary.secAquaGreen};
          }
          &:before {
            content: "/";
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            margin: 5px ${multiple + "px"} 0 ${multiple + "px"};
            color: ${nota.color.secondary.secAquaGreen};
          }
          &:first-child {
            &:before {
              display: none;
            }
          }
        }
      }
    }

    .requestInfoBtnWrapper {
      width: 35px;
      height: auto;
      position: relative;

      .requestInfoTooltip {
        position: absolute;
        top: -37px;
        padding: 5px 10px;
        border-radius: 0px;
        height: auto;
        width: auto;
        text-align: center;
        font-weight: bold;
        animation: infoPop 10s forwards;
        animation-iteration-count: 1;
        background-color: ${nota.color.secondary.orange};
        transition: all 1s ease;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
        pointer-events: none;
        z-index: 10;

        &::after {
          content: "";
          position: absolute;
          transform: rotate(45deg);
          display: block;
          height: 10px;
          width: 10px;
          left: 0;
          right: calc(-100% + 30px);
          bottom: -5px;
          margin: 0 auto;
          background-color: ${nota.color.secondary.orange};
        }

        p {
          color: ${nota.color.neutral.white};
          white-space: nowrap;
          line-height: normal;
          font-size: 12px;
          font-weight: normal;
        }
      }

      &:hover {
        .requestInfoTooltip {
          opacity: 1 !important;
        }
      }

      .requestInfoBtn {
        cursor: pointer;

        svg {
          height: 17px;
          width: auto;
        }
        &:hover {
          opacity: 0.7;
        }
      }
    }

    .editCardBtnWrapper {
      width: 35px;
      .editCardBtn {
        /* padding: ${multiple + "px"};
        padding-top: ${multiple / 2 + "px"}; */
        cursor: pointer;
        svg {
          width: 17px;
          path {
            fill: ${nota.color.neutral.NeuOne};
          }
        }
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }

  .imageWrapper {
    width: 100%;
    .imgVideoWrapper {
      width: 100%;
      position: relative;
      overflow: hidden;
      padding-bottom: calc(591.44 / 1127.34 * 100%);
      .videoWrapper {
        width: 100%;
        height: 100%;
        video {
          position: absolute;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .loader {
        width: 100%;
        height: 100%;
      }
      .imgWrapper {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .svgWrapper {
        width: 100%;
        height: 100%;
        object-fit: cover;
        svg {
          height: 100%;
          width: 100%;
        }
      }

      .labelWrapper {
        width: auto;
        height: auto;
        position: absolute;
        bottom: 15%;
        right: 0;
        .labelContainer {
          svg {
            width: 70px;
            height: auto;
            -webkit-filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
            filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
          }
        }
      }

      .btnsWrapper {
        width: auto;
        height: auto;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 168, 225, 0.5);
        .iconBtnWrapper {
          padding: ${multiple + "px"};
          margin: 0 ${multiple + "px"};
          cursor: pointer;
          svg {
            height: auto;
            width: 20px;
            path,
            rect {
              fill: ${nota.color.neutral.white};
            }
          }
          &:hover {
            opacity: 0.7;
          }
        }
      }
    }
  }

  .blockInfoWrapper {
    padding: ${multiple * 2 + "px"} ${multiple + "px"};
    .headerBlockWrapper {
      margin-bottom: ${multiple + "px"};
      .typeCard {
        h4 {
          text-transform: uppercase;
        }
        h5 {
          color: ${nota.color.main.default};
        }
      }
      .btnsWrapper {
        .iconContainer {
          width: auto;
          cursor: pointer;
          margin-left: ${multiple * 2 + "px"};
          .playlistIcon {
            height: 16px;
          }
          svg {
            height: 20px;
            width: auto;
            path {
              fill: ${nota.color.neutral.NeuOne};
            }
          }
          &:hover {
            opacity: 0.7;
          }
        }
        .activeIcon {
          svg {
            path {
              fill: ${nota.color.main.default};
            }
          }
        }
      }
    }
  }

  .videoDownloadHidden {
    display: none;
  }

  /* MEDIA QUERIES */
  @media only screen and (max-width: 520px) {
    .imageWrapper {
      .imgVideoWrapper {
        .labelWrapper {
          .labelContainer {
            svg {
              width: 42px;
            }
          }
        }
      }
    }
  }

  @keyframes infoPop {
    0% {
      transform: translateY(1px);
    }

    10% {
      transform: translateY(-10px);
    }

    20% {
      transform: translateY(1px);
    }

    30% {
      transform: translateY(-10px);
    }

    40% {
      transform: translateY(1px);
    }

    50% {
      transform: translateY(-10px);
    }

    60% {
      transform: translateY(1px);
    }

    70% {
      transform: translateY(-10px);
    }

    80% {
      transform: translateY(1px);
    }

    90% {
      transform: translateY(-10px);
    }

    98% {
      opacity: 1;
    }

    100% {
      opacity: 0;
      transform: translateY(1px);
    }
  }
`;

export class ProgrammeImageBlock extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      openVideo: false,

      imageError: false,
    };

    this.downloadVideoRef = React.createRef();
    this.videoRef = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("displaySearchChanged", this.onDisplaySearchChanged, false);
    window.addEventListener("visibilitychange", this.onVisibilitychange, false);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("displaySearchChanged", this.onDisplaySearchChanged, false);
    window.removeEventListener("visibilitychange", this.onVisibilitychange, false);
  }

  onDisplaySearchChanged = (e) => {
    if (e.detail === true) {
      if (this.videoRef?.current?.pause) this.videoRef.current.pause();
    }
  };

  onVisibilitychange = () => {
    if (this.videoRef?.current?.pause) this.videoRef.current.pause();
  };

  openVideo = () => {
    this.setState({ openVideo: true }, this.props.onVideoPlay);
  };

  downloadVideo = () => {
    this.downloadVideoRef.current.click();
  };

  openEdit = () => {
    window.open(this.props.card.editUrl, "_blank");
  };

  render() {
    return (
      <StyledProgrammeImageBlock flexDirection={"column"}>
        <NanoFlex flexDirection={"column"}>
          <NanoFlex className="headerCard" alignItems={"flex-end"} justifyContent={"space-between"}>
            <NanoFlex className="titleCard" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
              <Type.h2 title={this.translation.card.localTitle}>
                <b>{this.props.card.localTitle}</b>
              </Type.h2>
              <NanoFlex className="secTitlesCardWrapper" justifyContent={"flex-start"} alignItems={"flex-start"}>
                {/* Format Title -> Show When: Different Of Null | Different of Local Title */}
                {this.props.card.formatTitle && this.props.card.formatTitle !== this.props.card.localTitle && (
                  <NanoFlex className="secTitlesCard" title={this.translation.card.formatTitle} justifyContent={"flex-start"} alignItems={"flex-start"}>
                    <Type.h4>{this.props.card.formatTitle}</Type.h4>
                  </NanoFlex>
                )}
                {/* Original Title -> Show When: Different Of Null | Different of Format Title | Different of Local Title */}
                {this.props.card.originalTitle && this.props.card.originalTitle !== this.props.card.formatTitle && this.props.card.originalTitle !== this.props.card.localTitle && (
                  <NanoFlex className="secTitlesCard" title={this.translation.card.originalTitle} justifyContent={"flex-start"} alignItems={"flex-start"}>
                    <Type.h4>{this.props.card.originalTitle}</Type.h4>
                  </NanoFlex>
                )}
              </NanoFlex>
            </NanoFlex>

            {this.props.card.editUrl && (
              <NanoFlex className="editCardBtnWrapper" justifyContent={"flex-end"} alignItems={"flex-start"}>
                <NanoFlex className="editCardBtn" justifyContent={"flex-end"} alignContent={"flex-start"} onClick={this.openEdit}>
                  <EditCard />
                </NanoFlex>
              </NanoFlex>
            )}

            <NanoFlex className="requestInfoBtnWrapper" justifyContent={"flex-end"}>
              <NanoFlex className="requestInfoTooltip">
                <Type.p>More analysis on request</Type.p>
              </NanoFlex>
              <NanoFlex className="requestInfoBtn" onClick={this.props.onInformationRequestClick}>
                <RequestInfoIcon />
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex className="imageWrapper" alignItems={"flex-start"}>
            <div className="imgVideoWrapper">
              {this.state.openVideo && (
                <div className="videoWrapper">
                  <video autoPlay controls ref={this.videoRef}>
                    <source src={`${this.props.card.video}#t=0.1`} type="video/mp4" />
                  </video>
                </div>
              )}
              {!this.state.openVideo && (
                <div className="imgWrapper">
                  <Image
                    imageUrl={this.props.card.image}
                    alt={"Default Card"}
                    onError={(error) => {
                      this.setState({ imageError: error });
                    }}
                  />

                  {this.props.card.isNotaSelection && (
                    <NanoFlex className="labelWrapper">
                      <NanoFlex className="labelContainer">
                        <NotaSelectionLabel />
                      </NanoFlex>
                    </NanoFlex>
                  )}

                  {!this._isExport && this.props.card.video && this.props.hasVideo && (
                    <NanoFlex className="btnsWrapper">
                      <NanoFlex className="iconBtnWrapper" onClick={this.openVideo}>
                        <PlayIcon />
                      </NanoFlex>
                      <NanoFlex className="iconBtnWrapper" onClick={this.downloadVideo}>
                        <Download />
                        <a className="videoDownloadHidden" ref={this.downloadVideoRef} href={this.props.card.video} download onClick={this.props.onVideoDownload} />
                      </NanoFlex>
                    </NanoFlex>
                  )}
                </div>
              )}
            </div>
          </NanoFlex>
        </NanoFlex>
      </StyledProgrammeImageBlock>
    );
  }
}

// Set default props
ProgrammeImageBlock.defaultProps = {
  card: {},
};

export default ProgrammeImageBlock;

// --- // Documentation // --- //
/*
import ProgrammeImageBlock from './../Partial/ProgrammeImageBlock.js';

<ProgrammeImageBlock/>
*/
